<a
    [routerLink]="[path]"
    routerLinkActive="active"
    queryParamsHandling=""
    tabindex="-1"
    >{{ title }}</a
>
